import { getAccountRequirementTemplatesItem } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { USER_REQUIREMENTS_PAGE_SIZE } from '../constants/useRequirementsPageSize';

export const getUserRequirementsTemplateList = (state: IRootState) => state.userRequirements.templatesList;
export const getUserRequirementsTotalCount = (state: IRootState) => state.userRequirements.totalCount;
export const getUserRequirementsPage = (state: IRootState) => state.userRequirements.page;
export const getUserRequirementsPageCount = (state: IRootState) => state.userRequirements.pageCount;
export const getUserRequirementsOrder = (state: IRootState) => state.userRequirements.order;
export const getUserRequirementsActiveTemplateId = (state: IRootState) => state.userRequirements.activeTemplateId;
export const getUserRequirementsTemplates = (state: IRootState) =>
  getAccountRequirementTemplatesItem(state, {
    order: getUserRequirementsOrder(state),
    page: getUserRequirementsPage(state).toString(),
    size: USER_REQUIREMENTS_PAGE_SIZE,
  });
